import { Component, OnInit} from "@angular/core";
import { AuthService } from "@app/service/auth.service";
import { environment } from "@env";
import {

  NbMenuService,
  NbSidebarService,
  NbThemeService
} from "@nebular/theme";
import {  map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NbDialogService } from "@nebular/theme";
import { OktaAuthService } from "@okta/okta-angular";
const issuer = environment.OKTA_ISSUER;
const redirectUri = `${window.location.origin}`;
import { Router } from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  public version = environment.version;
  public isAuthenticated = this.authService.getUser() !== null;
  public authUser: any;
  userPictureOnly: boolean = false;
  userMenu = [{ title: "Profile" }, { title: "Log out" }];
  currentTheme = "dark";
  private destroy$: Subject<void> = new Subject<void>();
  themes = [
    {
      value: "default",
      name: "Light"
    },
    {
      value: "dark",
      name: "Dark"
    },
    {
      value: "cosmic",
      name: "Cosmic"
    },
    {
      value: "corporate",
      name: "Corporate"
    }
  ];



  public nbContextMenuItems = [
    { title: "Sign In", data: { id: "sign-in", link: "/corporate/home" } },
    { title: "Profile", data: { id: "profile", link: "/profile" } },

  ];

  constructor(
    private themeService: NbThemeService,
    public authService: AuthService,
    private nbMenuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private dialogService: NbDialogService,
    public oktaAuth: OktaAuthService,
    private router: Router
  ) {}

  async ngOnInit() {
    /***
     * Place to change the application theme
     * **/

    this.changeTheme(this.themes[0].value);
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (this.isAuthenticated){
      this.nbContextMenuItems.push({title: "Log out", data: {id: "logout", link: "/auth/login"}})
     }
    // Subscribe to authentication state changes
    this.oktaAuth.$authenticationState.subscribe((isAuthenticated: boolean) => {
      this.isAuthenticated = isAuthenticated;

    });

     this.nbMenuService.onItemClick().subscribe(a => {
      if (a.item.data.id === "logout") {
        this.logout();
      }
      if (a.item.data.id === "profile") {
        alert("Page Under Construction");

      }
      if (a.item.data.id === "sign-in") {
        this.router.navigate(['/corporate/home']);
      }
    });

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe(themeName => (this.currentTheme = themeName));
  }
  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  async logout() {
    if (confirm("Are you sure you want to log out?")) {
      const idToken = await this.oktaAuth.getIdToken();
      await this.oktaAuth.logout("/");
      window.location.href = `${issuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}`;
      this.nbContextMenuItems.splice(2,1);
    }
  }
  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "left");
    return false;
  }
}
